/**
 * YELV Plan System
 * Single source of truth for plan tiers
 * 
 * Database values: 'dream' and 'build' (legacy, kept for DB compatibility)
 * Display names: 'Capture' and 'Execute'
 */

export const PLAN = {
  CAPTURE: 'dream',   // DB value
  EXECUTE: 'build',   // DB value
} as const;

export type PlanType = typeof PLAN[keyof typeof PLAN];

export const PLAN_DISPLAY_NAMES: Record<PlanType, string> = {
  [PLAN.CAPTURE]: 'Capture',
  [PLAN.EXECUTE]: 'Execute',
};

export const PLAN_PRICES: Record<PlanType, string> = {
  [PLAN.CAPTURE]: 'Free',
  [PLAN.EXECUTE]: '$7.99/mo',
};

/**
 * Check if a user has the Execute (paid) plan
 */
export function isExecute(plan: string | null | undefined): boolean {
  return plan === PLAN.EXECUTE;
}

/**
 * Check if a user has the Capture (free) plan
 */
export function isCapture(plan: string | null | undefined): boolean {
  return !plan || plan === PLAN.CAPTURE;
}

/**
 * Get display name for a plan
 */
export function getPlanDisplayName(plan: string | null | undefined): string {
  if (isExecute(plan)) return PLAN_DISPLAY_NAMES[PLAN.EXECUTE];
  return PLAN_DISPLAY_NAMES[PLAN.CAPTURE];
}

/**
 * Get price for a plan
 */
export function getPlanPrice(plan: string | null | undefined): string {
  if (isExecute(plan)) return PLAN_PRICES[PLAN.EXECUTE];
  return PLAN_PRICES[PLAN.CAPTURE];
}

// Legacy aliases for backward compatibility
export const isBuild = isExecute;
export const isDream = isCapture;
